export default __webpack_public_path__ + "static/media/impact_cover.67b6b2df.webp";